import { addMainControls, addOverlayControls } from '@eb/eds-structure';
import { setLanguage } from '@eb/i18n';
import { addDimensions, trackAnalyticsEvent } from '@eb/site-analytics';
import React from 'react';
import ContactOrganizerRoot from './components/ContactOrganizer/ContactOrganizerRoot';
import FollowOrganizerRoot from './components/FollowOrganizer/FollowOrganizerRoot';
import NotificationRoot from './components/Notification/NotificationRoot';
import OverlayRoot from './components/Overlay/OverlayRoot';
import RelatedEventsRoot from './components/RelatedEvents/RelatedEventsRoot';
import ShareEventRoot from './components/ShareEvent/ShareEventRoot';
import { AppProps, ControlledProps } from './types';

const setUpDimensions = (props: AppProps): void => {
    const {
        app_name: appName,
        app_version: appVersion,
        event,
        gaSettings,
    } = props;
    const {
        activeScopeUserId,
        correlationId,
        guestPartnerId,
        userPartnerId: userId,
        guestPartnerId: guestId,
    } = gaSettings;
    const {
        id: eventId,
        ownerId: eventOwnerUserId,
        source: eventSource,
    } = event;

    const dimensions = {
        activeScopeUserId,
        appName,
        appVersion,
        correlationId,
        eventId,
        eventOwnerUserId,
        eventSource,
        experimentId: 'OldListing',
        guestId,
        guestPartnerId,
        userId,
    };

    addDimensions(dimensions);
};

const ControlledListingComponents = (props: ControlledProps) => (
    <>
        <NotificationRoot {...props} />
        <RelatedEventsRoot {...props} />
        <OverlayRoot {...props} />
    </>
);

const EnhancedListingComponents = addOverlayControls(
    addMainControls(ControlledListingComponents),
);

export const App: React.FC<AppProps> = (props: AppProps) => {
    const { locale } = props.env.localeInfo;
    setLanguage(locale);

    setUpDimensions(props);
    trackAnalyticsEvent({
        action: 'AppLoad',
        category: 'listing',
    });

    return (
        <div data-spec="listing-page-app">
            <ShareEventRoot {...props} />
            <FollowOrganizerRoot {...props} />
            <ContactOrganizerRoot {...props} />
            <EnhancedListingComponents {...props} />
        </div>
    );
};
